import { useState, useEffect } from 'react'

interface GeoData {
  zipCode: string
  city: string
  state: string
}

const FALLBACK_ZIP = '33303'

export function useGeoLocation() {
  const [geo, setGeo] = useState<GeoData>({
    zipCode: FALLBACK_ZIP,
    city: '',
    state: '',
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchGeo = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/')
        if (!response.ok) throw new Error('Geo lookup failed')
        const data = await response.json()
        if (data.postal) {
          setGeo({
            zipCode: data.postal,
            city: data.city || '',
            state: data.region_code || '',
          })
        }
      } catch {
        // Silently fall back to default zip
      } finally {
        setLoading(false)
      }
    }

    fetchGeo()
  }, [])

  return { geo, loading }
}
